import { type MCPServerInfo } from '../../types';

const DataforseoServer: MCPServerInfo = {
  serverId: 'DATAFORSEO',
  name: 'DataForSEO',
  slug: 'dataforseo',
  description: 'DataForSEO MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/dataforseo/mcp-server-typescript',
    commitSha: '074db32',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['dataforseoPassword', 'dataforseoUsername'],
    properties: {
      dataforseoFullResponse: {
        type: 'string',
        description:
          'If set to true, the server will return the full API responses.',
        sensitive: false
      },
      dataforseoPassword: {
        type: 'string',
        description: 'Password for DataForSEO',
        sensitive: true
      },
      dataforseoUsername: {
        type: 'string',
        description: 'Username for DataForSEO',
        sensitive: false
      },
      enabledModules: {
        type: 'string',
        description:
          'Comma-separated list of enabled modules. If empty, all modules are enabled.',
        sensitive: false
      }
    }
  }
};

export default DataforseoServer;
